import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/posts";

export default function CategoryGrid() {
  return (
    <section id="categories" className="scroll-mt-24 border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <SectionHeading
          eyebrow="Topics"
          title="选一个主题，看看大家在聊什么"
          desc="六大主题覆盖城市、生活、科技、职场、文娱与出行，总有一个角落装着你想说的话。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => (
            <a
              key={category.key}
              href="#feed"
              className={`group flex cursor-pointer flex-col rounded-lg border border-background-200 p-6 transition-colors hover:border-primary-300 hover:bg-background-50 ${
                index === 0 ? "bg-background-50" : "bg-background-50/60"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${category.icon} text-2xl`} aria-hidden="true" />
                </span>
                <span className="font-label text-xs text-foreground-500">{category.count.toLocaleString("en-US")} 条</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {category.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 font-label text-sm text-primary-700">
                进入板块
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}